// core imports
import { useSearchParams } from "react-router-dom";
import { useCookies } from "react-cookie";
import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { hasDifferentLayout, isFes, showEssay } from "./utils/diffentLayoutCheck";
import {
  fetchArticlesData,
  getArticlesForDownload,
} from "./store/search-actions";
import "./App.css";
// components
import SideContainer from "./components/UI/SideContainer";
import Pagination from "./components/UI/Pagination";
import ArchiveSearchField from "./components/Container/ArchiveSearchField";
import AdvanceSearch from "./components/Container/AdvanceSearch";
import ArticlesList from "./components/Container/ArticlesList";
// utilities
import { bodyObjectBuilder } from "./utils/queryBuilder";
import {
  searchParamsBuilder,
  searchParamsReader,
} from "./utils/utilsFunctions";
import Filters from "./components/Container/Filters";
import CounterBar from "./components/UI/CounterBar";
import CustomHeaders from "./components/UI/CustomHeaders";
import MobileFiltersContainer from "./components/UI/MobileFiltersContainer";
import SyllabusCSV from "./components/UI/SyllabusCSV";
import { FakeLogin } from "./components/UI/FakeLogin";
import { FesEssay } from "./components/UI/FesEssay";

let firstSearch = true;
function App() {
  const dispatch = useDispatch();
  const brandColor = process.env.REACT_APP_PRIMARY_COLOR || "#00ff00";
  const brandFont = process.env.REACT_APP_BRAND_FONT || "Pressura_light";
  const secondaryBrandFont =
    process.env.REACT_APP_SECONDARY_BRAND_FONT || "Pentameter";
  const cardTitleFontSize = process.env.REACT_APP_CARD_TITLE || "1.75rem";
  const filterTitleFontSize = process.env.REACT_APP_FILTER_TITLE || "1.25rem";
  const filterValueFontSize = process.env.REACT_APP_FILTER_VALUE || "1rem";
  const isPrivate = Boolean(process.env.REACT_APP_IS_PRIVATE) || false;
  const isTestMode = Boolean(process.env.REACT_APP_TEST_MODE) || false;
  const projectWithAdvancedSearch =
    Boolean(process.env.REACT_APP_ADVANCED_SEARCH) || true;
  const bgColor = "#a5cd3e";
  const articlesList = useSelector((state) => state.search.articles);
  const totalArticles = useSelector((state) => state.search.totalArticles);
  const isLoading = useSelector((state) => state.search.loading);
  let [searchParams, setSearchParams] = useSearchParams();
  const [showAdvanceSearch, setShowAdvanceSearch] = useState(false);
  const [mobileFilters, setMobileFilters] = useState(false);
  const [hasLogged, setHasLogged] = useState(false);
  const [advanceSearchQuery, setAdvanceSearchQuery] = useState(null);

  // eslint-disable-next-line
  const [error, setError] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [cookies, setCookie] = useCookies(["tokenSearch"]);

  if (isPrivate) {
    // only for THE SYLLABUS
    const tokenForSearch = searchParams.get("ursTkn");
    if (!cookies || !cookies.tokenSearch) {
      /*  if(!tokenForSearch) {
      window.location = "https://www.the-syllabus.com/cabinet";
      return
    }  */
      setCookie("tokenSearch", `${tokenForSearch}`, {
        path: "/",
        maxAge: 864000, // Expires after 1day
        sameSite: true,
      });
    }
  }

  const [hasAdvanceQuery, setHasAdvaceQuery] = useState(false);

  const handleSearchInput = (val) => {
    const simpleSearchQuery = {
      query: val,
      attribute: "",
    };
    if (firstSearch) {
      firstSearch = false;
      const params = searchParamsReader(searchParams.entries());
      dispatch(
        fetchArticlesData(
          bodyObjectBuilder(params.pageNumber, params.queries),
          isPrivate ? cookies.tokenSearch : undefined
        )
      );
    } else {
      const params = searchParamsReader(searchParams.entries());
      const newParams = params.queries.filter((e) => e.attribute.length > 0);
      newParams.push(simpleSearchQuery);
      const filters = Object.keys(params.filters).length ? params.filters : {};
      setSearchParams(searchParamsBuilder(newParams, 0, filters));
    }
  };
  const openAdvanceSearch = () => {
    setShowAdvanceSearch(true);
  };
  const resetAdvancedQueryHandler = () => {
    const simpleSearchQuery = {
      query: "",
      attribute: "",
    };
    setHasAdvaceQuery(false);
    setSearchParams(searchParamsBuilder([simpleSearchQuery], 0));
    setAdvanceSearchQuery(null);
  };
  const closeAdvance = () => {
    setShowAdvanceSearch(false);
  };
  const showFiltersMobile = () => {
    setMobileFilters(true);
  };
  const closeMobileFilters = () => {
    setMobileFilters(false);
  };
  const advanceSearchHandler = (paramsList) => {
    setAdvanceSearchQuery(paramsList);
    const advanceQueryList = [];
    Object.keys(paramsList).forEach((k) => {
      advanceQueryList.push({
        query: paramsList[k].textValue,
        attribute: paramsList[k].type === "*" ? "" : paramsList[k].type,
      });
    });
    setSearchParams(searchParamsBuilder(advanceQueryList, 0));
    setHasAdvaceQuery(true);
    setShowAdvanceSearch(false);
  };
  const handlePageChange = (page) => {
    const params = searchParamsReader(searchParams.entries());
    setSearchParams(searchParamsBuilder(params.queries, page, params.filters));
  };
  const handleFilesDownload = (isCSV = false) => {
    const params = searchParamsReader(searchParams.entries());

    dispatch(
      getArticlesForDownload(
        isCSV,
        bodyObjectBuilder(params.pageNumber, params.queries, params.filters),
        isPrivate ? cookies.tokenSearch : undefined
      )
    );
  };
  const fakeLoginHandler = (user, pwd) => {
    if (user === "tsuser" && pwd === "ts2023") {
      localStorage.setItem("hasLogged", true);
      setHasLogged(true);
    }
  };
  useEffect(() => {
    const params = searchParamsReader(searchParams.entries());
    const containerDiv = document.getElementById("articles-container");
    containerDiv.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    // setHasAdvaceQuery(advanceQueryChecker(params.queries))
    setCurrentPage(Number(params.pageNumber));
    dispatch(
      fetchArticlesData(
        bodyObjectBuilder(params.pageNumber, params.queries, params.filters)
      )
    );
    // eslint-disable-next-line
  }, [searchParams]);

  useEffect(() => {
    if (isTestMode) {
      const storageHasLogged = localStorage.getItem("hasLogged") || false;
      setHasLogged(storageHasLogged);
    }
    // eslint-disable-next-line
  }, []);
  return (
    <div className="App relative w-full h-screen flex flex-col">
      <style
        dangerouslySetInnerHTML={{
          __html: `:root {
                    --main-color: ${brandColor};
                    --secondary-color: ${bgColor};
                    --font:  ${brandFont};
                    --secondary-font: ${secondaryBrandFont};
                    --card-title: ${cardTitleFontSize};
                    --filter-title: ${filterTitleFontSize};
                    --filter-value: ${filterValueFontSize}
                  }`,
        }}
      />
      <CustomHeaders />
      <ArchiveSearchField
        setField={handleSearchInput}
        projectWithAdvancedSearch={projectWithAdvancedSearch}
        buttonHandler={openAdvanceSearch}
        resetHandler={resetAdvancedQueryHandler}
        hasAdvanceQuery={hasAdvanceQuery}
        queries={searchParamsReader(searchParams.entries()).queries}
        showFiltersMobile={showFiltersMobile}
      />
      {isTestMode && !hasLogged ? (
        <FakeLogin clickHandler={fakeLoginHandler} />
      ) : null}
      {showAdvanceSearch && (
        <AdvanceSearch
          advanceSearchQuery={advanceSearchQuery}
          closeSearch={closeAdvance}
          setAdvanceSearch={advanceSearchHandler}
        />
      )}
      <div
        className={`w-full flex flex-col lg:flex-row h-full ${
          hasDifferentLayout()
            ? isFes()
              ? "pt-[170px] lg:pt-[150px]"
              : "pt-[170px] lg:pt-[140px]"
            : "pt-[100px] lg:pt-[70px]"
        }`}
      >
        <SideContainer>
          <Filters />
        </SideContainer>
        <MobileFiltersContainer
          closeMobileFilters={closeMobileFilters}
          isOpen={mobileFilters}
        >
          <Filters />
        </MobileFiltersContainer>
        <div
          className="flex lg:grow lg:max-w-3/4 max-lg:w-full lg:w-3/4 flex-col overflow-y-auto h-full"
          id="articles-container"
        >
          {isTestMode ? (
            <SyllabusCSV buttonHandler={handleFilesDownload} />
          ) : null}
          {isFes() && showEssay() ? (
           <FesEssay />
          ) : null}
          <CounterBar
            articlesNumber={totalArticles}
            pageNumber={currentPage}
            reset={resetAdvancedQueryHandler}
          />
          <ArticlesList
            isLoading={isLoading}
            articlesList={articlesList}
            error={error}
          />
          {!isLoading && articlesList.length ? (
            <div className="w-full flex items-center justify-center mb-5">
              <Pagination
                handlePageClick={handlePageChange}
                currentPage={currentPage}
              />
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
}

export default App;
